export var Settings = {
    itemsPerPage: 20,
    wsUrl: "/api/search",
    sdsWsUrl: "/api/sds",
    downloadsWsUrl: "/api/download/save",
    docFinderUrl: "/Solutions/Document-Finder",
    hiddenTabs: "",
    hiddenFacets: "",
    fixedFilter: "", //fixed filter coming via the config
    appPrefix: "",
    useRanking: true,
    showPromotedResults: false,
    restrictSDSLinkToBUs: "",
    sdsFileTitleFormat: "SDS for {country} version {version} ({language})",
    allowBulkNumberSearch: false,
    showPastEvents: false,
    fixedQueryFilters: { //fixed filters coming via the query string
        industry_sm: [],
        application_sm: [],
        productfunction_sm: [],
        compound_sm: [],
        business_unit_sm: [],
        business_line_sm: [],
        event_year_tl: [],
        event_month_tl: [],
        corporate_area_sm: [],
        news_year_tl: [],
        news_month_tl: []
      },
    products: {
        collapsedFacets: ["Industries", "Applications", "Functions", "Business Units", "Business Lines"],
        extraFacets: ""
    },
    pages: {
        collapsedFacets: ["Corporate", "Business Units", "Business Lines"]
    },
    news: {
        collapsedFacets: ["Month", "Corporate", "Business Unit", "Industries"]
    },
    events: {
        collapsedFacets: ["Month", "Corporate", "Business Units", "Business Lines"]
    },
    downloads: {
        collapsedFacets: []
    },
    blog: {
        collapsedFacets: ["Month", "Corporate", "Business Unit", "Industries"]
    },
    recommended: {
        collapsedFacets: ["Month", "Corporate", "Business Unit", "Industries"]
    },
    init() {
        var sws = document.getElementById("searchwsurl");
        if (sws) this.wsUrl = sws.value;
        
        var ipp = document.getElementById("itemsperpage");
        if (ipp) this.itemsPerPage = parseInt(ipp.value);
        if (this.itemsPerPage <= 0) this.itemsPerPage = 20;
        var dws = document.getElementById("downloadwsurl");
        if (dws) this.downloadsWsUrl = dws.value;

        var dfu = document.getElementById("docfinderurl");
        if (dfu) this.docFinderUrl = dfu.value;

        var ht = document.getElementById("hiddentabs");
        if (ht) this.hiddenTabs = ht.value;
        var hf = document.getElementById("hiddenfacets");
        if (hf) this.hiddenFacets = hf.value;
        var ff = document.getElementById("fixedfilter");
        if (ff) this.fixedFilter = ff.value;
        var ap = document.getElementById("appprefix");
        if (ap) this.appPrefix = ap.value;
        var r = document.getElementById("useranking");
        if (r) this.useRanking = r.value !== "false";

        var pr = document.getElementById("showpromotedresults");
        if (pr) this.showPromotedResults = pr.value === "true";

        var pe = document.getElementById("showpastevents");
        if (pe) this.showPastEvents = pe.value === "true";

        //collapsed facets
        var cf = document.getElementById("products-collapsed-facets");
        if (cf) this.products.collapsedFacets = cf.value ? cf.value.split("|") : [];
        var ef = document.getElementById("products-extra-facets");
        if (ef) this.products.extraFacets = ef.value || "";
        cf = document.getElementById("pages-collapsed-facets");
        if (cf) this.pages.collapsedFacets = cf.value ? cf.value.split("|") : [];
        cf = document.getElementById("news-collapsed-facets");
        if (cf) this.news.collapsedFacets = cf.value ? cf.value.split("|") : [];
        cf = document.getElementById("events-collapsed-facets");
        if (cf) this.events.collapsedFacets = cf.value ? cf.value.split("|") : [];
        cf = document.getElementById("downloads-collapsed-facets");
        if (cf) this.downloads.collapsedFacets = cf.value ? cf.value.split("|") : [];
        cf = document.getElementById("blog-collapsed-facets");
        if (cf) this.blog.collapsedFacets = cf.value ? cf.value.split("|") : [];

        //sds stuff
        var sdsws = document.getElementById("sdswsurl");
        if (sdsws) this.sdsWsUrl = sdsws.value;
        var rsds = document.getElementById("restrictsdslinktobus");
        if (rsds) this.restrictSDSLinkToBUs = rsds.value;
        let abns = document.getElementById("allow-bulk-number-search");
        if (abns) {
            this.allowBulkNumberSearch = (abns.value === "true" || abns.value === "1");
        }
        let sdsft = document.getElementById("sds-file-title-format");
        if (sdsft) {
            this.sdsFileTitleFormat = sdsft.value;
        }
    },
    getFirstVisibleTab() {
        let tabs = "products,pages,downloads,news,events,blog";
        let firstVisibleTab = "";
        let hiddenTabs = this.hiddenTabs;
        tabs.split(",").map(function (tab) {
            if (!firstVisibleTab && hiddenTabs.indexOf(tab) === -1) firstVisibleTab = tab;
        });
        return firstVisibleTab;
    }
}